<template>
  <div>
    <Banners
      :src="require('@/assets/img/aboutUs/banner2.jpg')"
      :title="projectCategories.name ? projectCategories.name : ''"
      :text="projectCategories.intro ? projectCategories.intro : ''"
    ></Banners>
    <!-- 待启动项目 -->
    <b-container class="home-margin">
      <Title title="待启动项目" :left="true"></Title>
      <b-row class="wait-project">
        <b-col
          cols="12"
          md="4"
          v-for="(item, index) in projectWaitData"
          :key="index"
          @click="ProjectDetail(item.id)"
        >
          <img :src="getImgUrl(item.projectPhotoUrl)" />
          <div class="wait-content">
            <h5 class="maxLength-text-1">
              {{ item.name ? item.name : "" }}
            </h5>
            <div class="flex-text">
              <div class="projects-flex-text">
                <span>项目类型</span>
                <Category :categoryId="item.categoryId"></Category>
              </div>
              <div class="projects-flex-text">
                <span>项目行业</span>
                <p v-if="item.industry">{{ item.industry.name }}</p>
              </div>
              <div class="projects-flex-text">
                <span>开始时间</span>
                <p>{{ changeDataTime(item.startDate) }}</p>
              </div>
            </div>
            <p v-html="item.projectRequire" class="p-16-6 wait-desc"></p>
            <div
              class="projects-wait-footer"
              v-if="item.areas && item.areas.length > 0"
            >
              <i></i>
              <span>
                {{ existData(item.areas[0], "provinceName", "") }}
                {{
                  item.areas[0] && item.areas[0].cityName
                    ? existData(item.areas[0], "cityName", " - ")
                    : ""
                }}
              </span>
            </div>
          </div>
        </b-col>
      </b-row>
      <div class="more-btn">
        <b-button variant="primary" @click="ProjectMore(routerId, 'pending')">
          更多项目
          <b-icon-arrow-right></b-icon-arrow-right>
        </b-button>
      </div>
    </b-container>
    <!-- 进行中项目 -->
    <b-container fluid class="start-project">
      <b-container>
        <Title title="进行中的项目" :left="true"></Title>
        <div>
          <CarouselPerson
            :carouselData="projectStartData"
            :DataType="DataType"
            :indicators="false"
            :fade="true"
            :controls="controlStart"
          ></CarouselPerson>
        </div>
        <div class="more-btn">
          <b-button variant="primary" @click="ProjectMore(routerId, 'allow')">
            更多项目
            <b-icon-arrow-right></b-icon-arrow-right>
          </b-button>
        </div>
      </b-container>
    </b-container>
    <b-container class="home-margin">
      <Title title="已完成的项目" :left="true"></Title>
      <CarouselPerson
        :carouselData="projectOverData"
        :DataType="DataType"
        :indicators="false"
        :fade="true"
        :controls="controlOver"
      ></CarouselPerson>

      <div class="more-btn">
        <b-button variant="primary" @click="ProjectMore(routerId, 'done')">
          更多项目
          <b-icon-arrow-right></b-icon-arrow-right>
        </b-button>
      </div>
    </b-container>
    <b-container class="home-nine wow fadeInDown join-white" fluid>
      <div class="join">
        <p>真诚的期待您加入</p>
        <b-button variant="primary" @click="loginChange" style="backgro">
          入汇吧
          <b-icon-arrow-right></b-icon-arrow-right>
        </b-button>
      </div>
    </b-container>
  </div>
</template>
<script>
import Api from "@/apis";
import publicChange from "@/assets/js/index.js";
import Category from "@/components/category.vue";
import CarouselPerson from "@/components/CarouselPerson.vue";
export default {
  data() {
    return {
      routerId: this.$route.query.id || 0,
      controlStart: false,
      controlOver: false,
      DataType: 2,
      hasPhone: false,
      tab: 0,
      page: {
        current: 1,
        rows: 1,
        perPage: 6,
        show: true
      },
      projectStartData: [],
      projectWaitData: [],
      projectOverData: [],
      personData: [],
      projectCategories: [],
      categoriesId: 0,
      projectMore: []
    };
  },
  components: {
    Category,
    CarouselPerson
  },
  watch: {
    $route: {
      handler(val) {
        const routerId = val.query.id;
        this.routerId = routerId;
        this.getProjectCategories(routerId);
        this.getProjectCategoriesList(routerId);
      },
      deep: true
    }
  },
  mounted() {
    this.getProjectCategories(this.routerId);
    this.getProjectCategoriesList(this.routerId);
    if (this._isMobile()) {
      this.hasPhone = true;
    } else {
      this.hasPhone = false;
    }
  },
  methods: {
    ProjectMore(id, status) {
      const login = this.login();
      if (login) {
        this.$router.push({
          path: `/product/list`,
          query: {
            id: id,
            status: status
          }
        });
      } else {
        this.$router.push({
          path: "/login",
          query: {
            redirect: location.href
          }
        });
        this.$message.warning("请先登录后查看更多项目");
      }
    },
    ProjectDetail(id) {
      const login = this.login();
      if (login) {
        this.$router.push({
          path: `/product/projectDetails`,
          query: {
            id: id
          }
        });
      } else {
        this.$router.push({
          path: "/login",
          query: {
            redirect: `/product/projectDetails?id=${id}`
          }
        });
        this.$message.warning("请先登录");
      }
    },
    //获取当前项目
    async getProject() {
      try {
        const query = {
          current: 1,
          filters: {
            flagRecommend: 1
          }
        };
        const data = await Api.Project.getProject(query);
        console.log(data);
      } catch (e) {
        this.$Message.error(e);
      }
    },
    //获取当前类别下所有项目
    async getProjectCategoriesList(id) {
      this.projectWaitData = [];
      this.projectStartData = [];
      this.projectOverData = [];
      this.controlStart = false;
      this.controlOver = false;
      try {
        const query = {
          current: 1,
          filters: {
            categoryId: id,
            flagRecommend: 1
          }
        };
        const data = await Api.Project.getProjectCategoriesList(query);
        if (data.data && data.data.length > 0) {
          let WaitArr = [];
          let StartArr = [];
          let OverArr = [];
          data.data.map(item => {
            switch (item.status) {
              case "pending":
                WaitArr.push(item);
                if (WaitArr && WaitArr.length > 0) {
                  this.projectWaitData = WaitArr.slice(0, 6);
                }
                break;
              case "allow":
                StartArr.push(item);
                if (StartArr && 6 >= StartArr.length > 0) {
                  this.controlStart = true;
                  let startArrData = [];
                  if (this.hasPhone) {
                    for (let i = 0; i < StartArr.length; i += 1) {
                      startArrData.push({
                        data: StartArr.slice(i, i + 1)
                      });
                    }
                  } else {
                    for (let i = 0; i < StartArr.length; i += 3) {
                      startArrData.push({
                        data: StartArr.slice(i, i + 3)
                      });
                    }
                  }
                  this.projectStartData = startArrData;
                }
                break;
              case "done":
                OverArr.push(item);
                if (OverArr && 6 >= OverArr.length > 0) {
                  this.controlOver = true;
                  let ArrData = [];
                  if (this.hasPhone) {
                    for (let i = 0; i < OverArr.length; i += 1) {
                      ArrData.push({
                        data: OverArr.slice(i, i + 1)
                      });
                    }
                  } else {
                    for (let i = 0; i < OverArr.length; i += 3) {
                      ArrData.push({
                        data: OverArr.slice(i, i + 3)
                      });
                    }
                  }
                  this.projectOverData = ArrData;
                }
            }
          });
        }
      } catch (e) {
        this.$Message.error(e);
      }
    },
    //获取项目类别
    async getProjectCategories(id) {
      try {
        const data = await Api.Project.getProjectCategoriesDetail(id);
        this.projectCategories = data;
      } catch (e) {
        this.$Message.error(e);
      }
    },
    //监听控制项目长度
    projectLength() {},
    onDesc(text) {
      return publicChange.disposeHtml(text);
    },
    login() {
      return publicChange.userLogin();
    },
    getImgUrl(img) {
      return publicChange.getStaticUrl(img);
    },
    existData(data, index, text) {
      return publicChange.existData(data, index, text);
    },
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    //转换时间戳
    changeDataTime(date) {
      let time = new Date(date);
      return this.$moment(time).format("YYYY.MM.DD");
    },
    loginChange() {
      if (this.login()) {
        this.$router.push("/user/talent");
      } else {
        this.$router.push("/login");
      }
    }
  }
};
</script>
<style scoped></style>
